<!--分项能耗分析-->
<template>
	<div class="ieCstatisticsBody">
		<div class="top">
			<el-form ref="form" :model="form" label-width="80px">
				<el-form-item label="能耗类型">
					<el-select v-model="form.type" placeholder="请选择活动区域">
						<el-option label="水" value="水"></el-option>
						<el-option label="电" value="电"></el-option>
						<el-option label="气" value="气"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="能耗变量">
					<el-select v-model="energyVariable" placeholder="请选择变量">
						<el-option :label="item.name" :value="item.name" v-for="item in energyVariableList"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="时间">
					<el-date-picker v-model="form.dataTime" type="date" placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item label-width="10px">
					<el-button type="primary" size="mini" @click="onSubmit">查询</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="bottom">
			<div class="bottom_rigth">
				<div class="bottom_rigth_top">
					<div class="bottom_rigth_top_div">
						<img :src="getImage('1yt.png')"/>
						<div>
							<p>累计用{{form.type}}量</p>
							<p style="color: #ee9700;">{{countAmount}}{{unit}}</p>
						</div>
					</div>
					<div class="bottom_rigth_top_div">
						<img :src="getImage('2yt.png')"/>
						<div>
							<p>折标煤</p>
							<p style="color: #ea5066;">{{getDiscount}}kgce</p>
						</div>
					</div>
					<div class="bottom_rigth_top_div">
						<img :src="getImage('5yt.png')"/>
						<div>
							<p>CO2排放量</p>
							<p style="color: #2edfff;">{{getEmissions}}kg</p>
						</div>
					</div>
				</div>
				<div class="bottom_rigth_center">
					<vchart ref="vchart1"></vchart>
				</div>
				<div class="bottom_rigth_bottom" v-if="isTabShow">
					<el-table :data="dataTable" style="width: 100%;max-height: 100%;">
						<el-table-column prop="name" label="变量名称" width="150" fixed>
						</el-table-column>
						<el-table-column v-for="(item,i) in tabColumn" :prop="getKey(i)" :label="item">
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import vchart from '@/components/module/chart/vchart.vue'
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		components: {
			vchart,
		},
		props: {},
		data() {
			return {
				form: {
					type: "电",
					dataTime: new Date(),
				},
				unit: "KWh",
				energyVariable: "",
				energyVariableList: [],
				appType: 36,
				countAmount: 0,
				dataTable: [],
				tabColumn: [],
				isTabShow: false,
				option1: {
					xAxis: {
						type: 'category',
						splitLine: {
							show: false
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: '#ffffff'
							}
						},
						axisTick: {
							show: false
						},
						axisLine: {
							show: true
						},
						data: []
					},
					yAxis: {
						type: 'value',
						splitLine: {
							lineStyle: {
								color: "#ffffff",
								type: 'dashed'
							}
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: '#ffffff'
							}
						},
						axisTick: { //y轴刻度线
							show: true
						},
						axisLine: { //y轴
							show: false
						},
					},
					grid: {
						right: '3%',
						left: '3%'
					},
					series: [{
						name: "",
						type: "bar",
						itemStyle: {
							color: "#38A0FF",
						},
						data: []
					}, ]
				},
			}
		},
		created() {},
		mounted() {
			this.$refs.vchart1.setData(this.option1)
			this.initData()
		},
		destroyed() {},
		computed: {
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			getDiscount() {
				let value = 0
				let coefficient = 0
				switch(this.form.type) {
					case '电':
						coefficient = 0.1229
						break;
					case '水':
						coefficient = 0.0857
						break;
					case '气':
						coefficient = 1.2143
						break;
				}
				if(this.countAmount != 0) {
					value = (this.countAmount * coefficient).toFixed(2)
				}
				return value
			},
			getEmissions() {
				return(this.getDiscount * 2.493).toFixed(2)
			},
			getImage() {
				return img => {
					return resourcesStore.getters.getResourcesByName('energyEfficiencySystem/statistics/' + img)
				}
			},
			getKey() {
				return(i) => {
					return "value" + i
				}
			}
		},
		watch: {
			'form.type': {
				deep: true,
				handler(nv, ov) {
					switch(nv) {
						case "电":
							this.unit = "Kwh"
							this.appType = 36
							break;
						case "水":
							this.unit = "m³"
							this.appType = 237
							break;
						case "气":
							this.unit = "Nm³"
							this.appType = 361
							break;
					}
					this.initData()
				}
			},
		},
		methods: {
			initData() {
				if(isempty(this.nowUnit.id)) {
					return
				}
				this.$api.areausePower.getAreausePiwerListUnitAndApptype(this.nowUnit.id, this.appType, respon => {
					if(!isempty(respon)) {
						respon.forEach(item => {
							item["name"] = item.areaname.split('_')[1]
						})
						this.energyVariableList = respon
					}
				})
			},
			onSubmit() {
				//拿到选中的变量详细信息
				let variable = ""
				//非空判断
				if(isempty(this.energyVariable)) {
					this.$message.warning("能耗变量不能为空")
					return
				}
				this.energyVariableList.forEach((item, i) => {
					if(this.energyVariable == item.areaname.split('_')[1]) {
						variable = item.relatVariabel
					}
				})
				this.dataTable = []
				this.$api.areausePower.getConsumptionAnalysis(variable, this.form.dataTime.getTime(), respon => {
					this.countAmount = respon.count
					this.tabColumn = respon.xData
					this.option1.xAxis.data = respon.xData
					let obj = {
						name: this.energyVariable
					}
					respon.barData.forEach((item, i) => {
						obj["value" + i] = item
					})
					this.isTabShow = true
					this.dataTable.push(obj)
					this.option1.series[0].data = respon.barData
					this.option1.series[0].name = this.energyVariable
					this.$refs.vchart1.setData(this.option1)
				})

			}
		}
	}
</script>

<style scoped>
	.ieCstatisticsBody {
		width: 100%;
		height: 100%;
		background-color: #11173c;
	}
	.ieCstatisticsBody .top {
		width: 100%;
		height: 8%;
		display: flex;
		align-items: center;
	}
	
	.ieCstatisticsBody .bottom {
		width: 100%;
		height: 92%;
	}
	
	.ieCstatisticsBody .bottom_left {
		width: 10%;
		height: 100%;
	}
	
	.ieCstatisticsBody .bottom_rigth {
		width: 100%;
		height: 100%;
	}
	
	.ieCstatisticsBody .bottom_rigth_top {
		width: 100%;
		height: 15%;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	
	.ieCstatisticsBody .bottom_rigth_top_div {
		width: 17%;
		height: 80%;
		background-color: #082d76;
		border-radius: .05rem;
		border: .01rem solid #045ae8;
		display: flex;
		align-items: center;
		justify-content: space-around;
		margin-left: 2%;
	}
	.ieCstatisticsBody .bottom_rigth_top_div img {
		width: .6rem;
		height: .6rem;
		padding-left: .1rem;
	}
	
	.ieCstatisticsBody .bottom_rigth_top_div div {
		width: 55%;
		height: 55%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}
	
	.ieCstatisticsBody .bottom_rigth_top_div p {
		color: white;
		font-size: .18rem;
	}
	
	.ieCstatisticsBody .bottom_rigth_center {
		width: 100%;
		height: 55%;
	}
	
	.ieCstatisticsBody .bottom_rigth_bottom {
		width: 100%;
		height: 30%;
	}
	
	.ieCstatisticsBody .default-chart {
		height: 100%;
	}
</style>
<style>
	.ieCstatisticsBody .el-form-item {
		margin-bottom: 0;
		margin-left: .2rem;
	}
	
	.ieCstatisticsBody .el-form {
		display: flex;
	}
	
	.ieCstatisticsBody label {
		color: white;
	}
	.ieCstatisticsBody .el-table {
		width: 100%;
		height: 100%;
		background-color: #11173c;
	}
	.ieCstatisticsBody .el-table th {
		background-color: #082d76;
		color: white;
		border: 0;
	}
	
	.ieCstatisticsBody .el-table th:nth-child(1) {
		color: #0aa4e9;
	}
	
	.ieCstatisticsBody .el-table td {
		background-color: #11173c;
		color: white;
		border: 0;
		border-top: .01rem solid #0774af;
	}
	
	.ieCstatisticsBody .el-table td:nth-child(1) {
		color: #0aa4e9;
	}
	
	.ieCstatisticsBody .el-table tr:hover>td {
		background-color: #00456b;
	}
	.ieCstatisticsBody .el-table__body .el-table__row.hover-row td {
		background-color: #00456b !important;
	}
	/*表单样式*/
	.ieCstatisticsBody .el-input__inner{
		background-color: #11173c;
		border: 1px solid #0775a5;
		color: white;
	}
	.ieCstatisticsBody .el-radio-group {
		margin-left: .2rem;
		background-color: #11173c;
	}
	.ieCstatisticsBody .el-radio-button__inner{
		background-color: #11173c;
		border: 1px solid #0775a5;
		color: white;
	}
	.ieCstatisticsBody .el-radio-button:first-child .el-radio-button__inner{
		border-left: 1px solid #0775a5;
	}
</style>